// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nsvg[data-v-c4061b2e] {\n  transform: rotate(-90deg);\n  top: calc(50px - 15px);\n  left: calc(50px - 15px);\n}\n.percent[data-v-c4061b2e] {\n  stroke-dasharray: 100;\n}\n", ""]);
// Exports
module.exports = exports;
